import React from "react";
import { useHistory } from "react-router";
import "./Profile.css";
import "../../responsive.css"

function AthleteAssessment({ name, path }) {
  const history = useHistory();
  return (
    <div className="athleteAssessment" style={{maxWidth:"105%"}}  onClick={() => history.push(`/${path}`)}>
      <div className="athleteAssessment__features">
        <div className="athleteAssessment__button">{name}</div>
        <img src="/assets/black_right.png" alt="" />
      </div>
    </div> 
  );
}

export default AthleteAssessment;
